import { render, staticRenderFns } from "./MobileCustom.vue?vue&type=template&id=3bcb7a01&scoped=true&"
import script from "./MobileCustom.vue?vue&type=script&lang=js&"
export * from "./MobileCustom.vue?vue&type=script&lang=js&"
import style0 from "./MobileCustom.vue?vue&type=style&index=0&id=3bcb7a01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb7a01",
  null
  
)

export default component.exports